import ContentLoader from "@funded-here-interface/common/src/components/ContentLoader/ContentLoader";
import StepsLayout from "@funded-here-interface/common/src/Layouts/StepsLayoutIndividual/StepsLayout";
import { FC, ReactNode, Suspense } from "react";

import NavBar from "../../components/NavBar/NavBar";
import { useStyles } from "./IndividualInvestor.styles";

interface IProps {
  content: ReactNode;
  showSteps?: boolean;
  step: number;
}

const IndividualInvestor: FC<IProps> = ({ content, showSteps, step }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <NavBar />
      {showSteps && <StepsLayout currentStep={step} />}
      <div className={classes.stepContainer}>
        <Suspense fallback={<ContentLoader />}>{content}</Suspense>
      </div>
    </div>
  );
};

export default IndividualInvestor;
